<template>
  <v-card flat height="100%">
    <v-card-title>
      <v-layout>
        <v-flex xs8 ma-2>Praxisstruktur.xml hochladen</v-flex>
        <v-spacer></v-spacer>
        <v-flex xs2 ma-2>
          <v-btn block color="primary" @click="forward">Weiter</v-btn>
        </v-flex>
      </v-layout>
    </v-card-title>
    <v-card-text v-if="!praxisstrukturUploaded">
      <v-alert text color="info">
        <h3 class="headline">Wichtige Hinweise</h3>
        <div>Liegt eine Praxisstruktur.xml aus einer Konvertierung vor, kann diese zur Datenübernahme für die Bestellung verwendet werden. Alle enthaltenen KV-Abrechnungsgruppen, Behandlungsorte und Ärzte werden übernommen.</div>
        <div>Wir empfehlen immer für die Bestellung eine Praxisstruktur.xml zu verwenden, da so keine inaktiven Behandlungsorte oder Ärzte fehlen.</div>
      </v-alert>
      <v-file-input
        :rules="inputRules"
        accept="text/xml"
        placeholder="Praxisstruktur.xml auswählen"
        v-model="file"
        small-chips
        show-size
        clearable
      ></v-file-input>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          @click="upload"
          :disabled="disableUploadButton"
        >Praxisstruktur.xml hochladen</v-btn>
      </v-card-actions>
    </v-card-text>
    <v-card-text v-if="praxisstrukturUploaded">
      <v-alert text color="info">
        <div>Es können nicht alle Daten automatisch aus der Praxisstruktur-Datei übernommen werden.</div>
        <div>Bitte überprüfen sie daher bei jedem Arzt den HZV Status und den inaktiv/aktiv Status.</div>
        <v-divider class="my-4 info" style="opacity: 0.22"></v-divider>
        <h3 class="headline">Aktuelle Übersicht</h3>
        <div>Behandlungsorte: {{bestellung.lizenz.behandlungsorte.length}}</div>
        <div>Ärzte: {{bestellung.lizenz.aerzte.length}}</div>
        <div
          v-if="bestellung.asvTeamsAktiv!==undefined && bestellung.asvTeamsAktiv!==null && bestellung.asvTeamsAktiv===true"
        >ASV-Teams: {{bestellung.lizenz.asvTeams.length}}</div>
        <div>KV-Abrechnungsgruppen: {{bestellung.lizenz.kvAbrechnungsgruppen.length}}</div>
      </v-alert>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      file: null,
      inputRules: [
        v =>
          !v ||
          v.size < 10000000 ||
          "Die Praxisstruktur.xml darf nicht größer als 10 MB sein!"
      ]
    };
  },
  computed: {
    ...mapState({
      process: state => state.current.process,
      bestellung: state => state.current.bestellung,
      praxisstrukturUploaded: state =>
        state.current.bestellung.praxisstrukturUploaded
    }),
    disableUploadButton: function() {
      return this.file == null;
    }
  },
  mounted: function() {
    if (
      this.$route.params.process != this.process ||
      this.bestellung === undefined
    ) {
      this.$store.commit("startLoading");
      this.$socket.sendObj({
        eventID:
          "de.t2med.lizenzomat.eventapi.usecase.order.BestellungRequestEvent",
        processId: this.$route.params.process,
        taskId: this.$route.params.task
      });
    }
  },
  methods: {
    forward: function() {
      this.$store.commit("startLoading");
      this.$socket.sendObj({
        eventID:
          "de.t2med.lizenzomat.eventapi.usecase.order.praxisstruktur.PraxisstrukturContinueRequestEvent",
        processId: this.$route.params.process,
        taskId: this.$route.params.task
      });
    },
    upload: function() {
      const encodingFileReader = new FileReader();
      encodingFileReader.onload = event => {
        const start = event.target.result.substring(
          event.target.result.indexOf("encoding") + 10,
          event.target.result.length
        );
        const encoding = start.substring(0, start.indexOf('"'));
        if (encoding === "UTF-8") {
          this.$store.commit("startLoading");
          this.$socket.sendObj({
            eventID:
              "de.t2med.lizenzomat.eventapi.usecase.order.praxisstruktur.PraxisstrukturSaveRequestEvent",
            processId: this.$route.params.process,
            taskId: this.$route.params.task,
            praxisstruktur: event.target.result
          });
        } else {
          const fileReader = new FileReader();
          fileReader.onload = event => {
            this.$store.commit("startLoading");
            this.$socket.sendObj({
              eventID:
                "de.t2med.lizenzomat.eventapi.usecase.order.praxisstruktur.PraxisstrukturSaveRequestEvent",
              processId: this.$route.params.process,
              taskId: this.$route.params.task,
              praxisstruktur: event.target.result
            });
          };
          fileReader.readAsText(this.file, encoding);
        }
      };
      encodingFileReader.readAsText(this.file, "UTF-8");
    }
  }
};
</script>
